import config from './config';

export default {
  namespaced: true,
  modules: {
    config,
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/config/index.js